import { render, staticRenderFns } from "./TenderDetail.vue?vue&type=template&id=2813017e&"
import script from "./TenderDetail.vue?vue&type=script&lang=js&"
export * from "./TenderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports